import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTranslation, Trans } from "react-i18next";
import "../../../resources/styles.scss";
import cardService from "../../../services/cardService";
import * as cardsStyles from "../cards.module.scss";
import { selectApplicationSettings } from "../../../state/selectors/app";
import cardTypes from "../../../constants/cardTypes";
import InputForProperty from "../../../components/inputs/inputForProperty";
import SelectForProperty from "../../../components/inputs/selectForProperty";
import CardLimits from "../Limits/card_limits";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import UserCardsTabView from "./components/userCardsTabView";

const emptyCard = {
  cardId: "00000000-0000-0000-0000-000000000000",
  cardType: "avto",
  cardNumber: "",
  cardNumberInternal: "",
  cardIButtonNumber: "",
  userName: "",
  car: "",
  carNumber: "",
  description: "",
  userPin: "",
  isActive: true,
  orderTs: new Date().toISOString()
};

const EditCard = (props) => {
  const { match, history, t, location } = props;
  const [card, setCard] = useState(Object.assign({}, emptyCard));
  const [isNewCard, setIsNewCard] = useState(false);
  const [limits, setLimits] = useState([]);
  const [userCardIds, setUserCardIds] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);

  const appSettings = useSelector((store) =>
    selectApplicationSettings()(store)
  );
  const isLimitsAvailable = !!appSettings.find(
    (s) => s.name === "LimitsAvailable"
  )?.value;

  const cardType = location?.state?.cardType;
  const backToPage = "/cards/cars";

  useEffect(() => {
    const cardId = match.params.id ? match.params.id : 0;
    getCard(cardId);
  }, []);

  const getCard = async (cardId) => {
    if (cardId === 0) {
      setLimits([]);
      setIsNewCard(true);
      setCard({ ...emptyCard, cardType });
      return;
    }
    const c = await cardService.getCardAsync(cardId);
    const lim = c.cardLimits.map((limit) => {
      return {
        item: limit,
        isEditable: false,
      };
    });

    setCard(c.card);
    setLimits(lim);
    setUserCardIds(c.userCardIds);
  };

  const updateCardProps = (propName, propValue) => {
    const state = Object.assign({}, card);
    state[propName] = propValue;
    setCard(state);
  };

  const setCardInternalNumber = (value) => {
    const state = Object.assign({}, card);
    const num = !value || value === "" ? 0 : parseInt(value);
    if (num < 0 || num > 99999999) return;

    state.cardNumberInternal = value;
    setCard(state);
  };

  const addUserCard = (userCardId) => {
    const updatedCards = [...userCardIds, userCardId];
    setUserCardIds(updatedCards);
  }

  const removeUserCard = (userCardId) => {
    const updatedCards = userCardIds.filter(x => x !== userCardId);
    setUserCardIds(updatedCards);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const limts = limits.map((limit) => {
      return limit.item;
    });
    var requestBody = { card: card, limits: limts, userCardIds };

    if (card.cardId === emptyCard.cardId) {
      await cardService.addCardAsync(requestBody);
    } else {
      await cardService.editCardAsync(requestBody);
    }

    history.replace(backToPage);
  };

  const cancelEditCard = (e) => {
    e.preventDefault();
    history.replace(backToPage);
  };

  return (
    <div className="form_container">
      <form className="edit-card-form" onSubmit={handleSubmit}>
        <div
          className={`form-body ${
            isLimitsAvailable ? "flex-row-border-content" : ""
          }`}
        >
          <div id="cardEdit">
            <div className="margin10">
              <div
                style={{ position: "relative" }}
                className={cardsStyles.card_limit_header}
              >
                <div>
                  <Trans>
                    {isNewCard ? "Cards.newCardHeader" : "Cards.editCardHeader"}
                  </Trans>
                </div>
              </div>
              <div>
                <p>
                  <SelectForProperty
                    header={t("Cards.cardType")}
                    disabled={true}
                    value={cardTypes.AVTO}
                    options={[
                      {
                        label: t("Cards.avtoCardType"),
                        value: cardTypes.AVTO,
                      },
                      {
                        label: t("Cards.userCardType"),
                        value: cardTypes.USER,
                      },
                    ]}
                    onChange={(value) => updateCardProps("cardType", value)}
                  ></SelectForProperty>
                </p>
                <p>
                  <InputForProperty
                    type="text"
                    header={t("Cards.cardRfidNumber")}
                    value={card.cardNumber}
                    onChange={(val) => updateCardProps("cardNumber", val)}
                  ></InputForProperty>
                </p>
                <p>
                  <InputForProperty
                    type="text"
                    header={t("Cards.cardIButtonNumber")}
                    propertyName="cardIButtonNumber"
                    value={card.cardIButtonNumber}
                    onChange={(val) =>
                      updateCardProps("cardIButtonNumber", val)
                    }
                  ></InputForProperty>
                </p>
                <p>
                  <InputForProperty
                    type="number"
                    header={t("Cards.cardNumber")}
                    value={card.cardNumberInternal}
                    onChange={(val) => setCardInternalNumber(val)}
                  ></InputForProperty>
                </p>
                <p>
                  <InputForProperty
                    type="text"
                    header={t("Cards.car")}
                    propertyName="car"
                    value={card.car}
                    onChange={(val) => updateCardProps("car", val)}
                  ></InputForProperty>
                </p>
                <p>
                  <InputForProperty
                    type="text"
                    header={t("Cards.description")}
                    propertyName="description"
                    value={card.description}
                    onChange={(val) => updateCardProps("description", val)}
                  ></InputForProperty>
                </p>
              </div>
            </div>
          </div>
          <Tabs>
            <TabList>
              <Tab>Limits</Tab>
              <Tab>Users</Tab>
            </TabList>
            <TabPanel>
              <CardLimits
                cardId={card.cardId}
                limits={limits}
                setLimits={setLimits}
              />
            </TabPanel>
            <TabPanel>
              <UserCardsTabView existingCards={userCardIds} onAddUser={addUserCard} onRemoveUser={removeUserCard}/>
            </TabPanel>
          </Tabs>
        </div>
        <div className="form-buttons-container">
          <button type="submit">
            <Trans>Table.saveButton</Trans>
          </button>
          <button onClick={cancelEditCard}>
            <Trans>Table.cancelButton</Trans>
          </button>
        </div>
      </form>
    </div>
  );
};

export default withRouter(withTranslation("translations")(EditCard));
